/** Contagem de interações no idioma da UI (ex.: 10.100 em pt-BR). */
export function formatCount(value: number, language: string): string {
  return new Intl.NumberFormat(language).format(value)
}

/** Data curta (dd/mm/aaaa) para validades e fim de teste. */
export function formatShortDate(value: string, language: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return value
  }
  return new Intl.DateTimeFormat(language, { dateStyle: 'short' }).format(date)
}
